import React, {useEffect, useState} from 'react';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import {Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Scatter, ScatterChart, XAxis, YAxis} from 'recharts';
import Title from '../miscellaneous/Title';
import {useStyles, urlapi} from "../miscellaneous/constants";
import Tooltip from "recharts/lib/component/Tooltip";
import {numberWithSpaces} from "../miscellaneous/functions";





const myStyles = makeStyles({
    root: {
        display: "flex",
        justifyContent: "space-between"
    },
    icon: {
        position: "absolute",
        right: "10"
    },
    tooltip: {
        zIndex: 10,
        border: "1px solid lightgrey",
        backgroundColor: "white",

    },
    div: {
        padding: "5px"
    },
    name: {
        padding: "5px",
        color: "#8884d8",
        textAlign: "center",
        backgroundColor: "lightgrey"
    }
});

function CustomTooltip(props) {
    const classes2 = myStyles();
    if (props.active === false)
        return null
    let name = props.payload[0].payload.name;
    if (name === undefined)
        return null
    let sz = name.length
    name = sz > 30 ? name.substring(0, 10) + " ... " + name.substring(sz - 10, sz) : name
    return (
        <div className={classes2.tooltip}>
            <div className={classes2.name}>{name}</div>
            <div className={classes2.div}>{props.payload[0].name + " : " + numberWithSpaces(props.payload[0].value)}</div>
            <div className={classes2.div}>{props.payload[1].name + " : " + numberWithSpaces(props.payload[1].value)}</div>
        </div>
    );
}


export default function MyScatter(props) {
    const theme = useTheme();
    const classes = useStyles;
    const classes2 = myStyles();





    let identity = [{t1: 1, t2: 1}, {t1: props.filters.timeLimit, t2: props.filters.timeLimit}]


    let ticks = [1];
    let current = 10;
    while (current <= props.filters.timeLimit) {
        ticks.push(current)
        current *= 10
    }
    const palette = [ "#3D91E0", "#952B60"]




    return (
        <React.Fragment>
            <Title>
                <div className={classes2.root} style={{color:'#408033'}}>Scatter Plot
                </div>
            </Title>
            <ResponsiveContainer>
                <ScatterChart margin={{top: 16, right: 16, bottom: 0, left: 24,}} width={400} height = {400}>
                    <Tooltip content={<CustomTooltip/>}/>
                    <Legend  verticalAlign="top" height={36}/>
                    <CartesianGrid/>
                    <XAxis scale='log' dataKey="t1" stroke={theme.palette.text.secondary}
                           name={props.graphSolvers.solver1.name + " " + props.graphSolvers.solver1.version} type="number"
                           allowDuplicatedCategory={false} domain={["1", props.filters.timeLimit]} ticks={ticks}
                           label={{ value: props.graphSolvers.solver1.name + " " + props.graphSolvers.solver1.version, position: 'insideBottom' }}
                    >
                    </XAxis>
                    <YAxis scale='log' stroke={theme.palette.text.secondary} dataKey="t2"
                           name={props.graphSolvers.solver2.name + " " + props.graphSolvers.solver2.version} type="number"
                           domain={["1", props.filters.timeLimit]} ticks={ticks}
                           label={{ value: props.graphSolvers.solver2.name + " " + props.graphSolvers.solver2.version, angle: -90, position: 'insideLeft' }}
                    >
                    </YAxis>
                    {Object.keys(props.data).map((key, index) => <Scatter name={key} data={props.data[key]} fill={palette[index % 2]}/>)}
                    <Scatter name="x" data={identity} line fill="black" legendType={'none'}/>
                </ScatterChart>
            </ResponsiveContainer>
        </React.Fragment>
    );
}
